/* Walnut "2 for $X" bundle builder (Proud, Oct 2026). Vanilla JS, no libraries.
   Prices in cents. The display must equal what Shopify charges, so everything derives from data.price and live variant prices. */
(function(){
  var root=document.querySelector('[data-wmb]');if(!root)return;
  var d=document,de=d.documentElement;
  function $(s){return root.querySelector(s)}

  /* offer ended (covers cached pages served after the end time) */
  var ends=+root.getAttribute('data-ends')||0;
  if(ends&&Date.now()>ends){
    var live=$('[data-wmb-live]'),bar0=$('[data-wmb-bar]'),end=$('[data-wmb-end]');
    if(live)live.remove();if(bar0)bar0.remove();if(end)end.hidden=false;root.classList.add('is-ended');return;
  }

  var dataEl=$('[data-wmb-data]');if(!dataEl)return;
  var J;try{J=JSON.parse(dataEl.textContent)}catch(e){return}
  var PRICE=J.price,QTY=J.qty||2,LABEL=J.label||'';
  var byKey={};J.cols.forEach(function(c){byKey[c.key]=c});
  if(!J.cols.length)return;
  var UNIT=J.cols[0].v[0]?J.cols[0].v[0].p:0;

  function money(c){return '$'+(c/100).toFixed(2)}
  function moneyShort(c){return c%100?money(c):'$'+(c/100)}
  function img(u,w){return u?u.replace(/width=\d+/,'width='+w):''}
  function esc(s){return String(s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]})}

  var slots=[];for(var i=0;i<QTY;i++)slots.push(null);
  var active=0,cur=J.cols[0].key,editing=false;
  var cols=$('[data-wmb-cols]'),sizes=$('[data-wmb-sizes]'),slotsEl=$('[data-wmb-slots]');
  var title=$('[data-wmb-title]'),msgEl=$('[data-wmb-msg]'),szLabel=$('[data-wmb-szlabel]');
  var atc=$('[data-wmb-atc]'),count=$('[data-wmb-count]'),meter=$('[data-wmb-meter]'),errEl=$('[data-wmb-err]');
  var wasEl=$('[data-wmb-was]'),wasLabel=$('[data-wmb-waslabel]'),saveEl=$('[data-wmb-save]');
  var bar=$('[data-wmb-bar]'),barS=$('[data-wmb-bars]'),barT=$('[data-wmb-bart]'),barP=$('[data-wmb-barp]'),barBtn=$('[data-wmb-barbtn]');
  var build=$('#build'),tray=$('[data-wmb-tray]');

  function filled(){var n=0;slots.forEach(function(s){if(s)n++});return n}
  function wasTotal(){var t=0;slots.forEach(function(s){t+=s?s.p:UNIT});return t}

  function renderCols(){[].forEach.call(cols.children,function(b){b.setAttribute('aria-pressed',b.getAttribute('data-key')===cur?'true':'false')})}
  function renderSizes(){
    var c=byKey[cur],h='',sel=slots[active];
    c.v.forEach(function(v){
      var on=!!(sel&&sel.id===v.id);
      h+='<button class="wm-sz" type="button" data-id="'+v.id+'" aria-pressed="'+on+'"'+(v.a?'':' disabled')+'>'+esc(v.s)+(v.a?'':'<small>Sold out</small>')+'</button>';
    });
    sizes.innerHTML=h;
    szLabel.textContent=sel&&sel.key===cur?'EU '+sel.s:'Select';
  }
  var X='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 5l14 14M19 5 5 19"/></svg>';
  function slotHTML(i){
    var s=slots[i],a=i===active?' active':'';
    if(!s)return '<button type="button" class="wmb-slot'+a+'" data-slot="'+i+'"><span class="wmb-slot__img">+</span><span class="wmb-slot__t"><small>Pair '+(i+1)+'</small>'+(i===active?'Choose a colour and size':'Empty')+'</span><span></span></button>';
    return '<div class="wmb-slot full'+a+'" data-slot="'+i+'" role="button" tabindex="0" aria-label="Edit pair '+(i+1)+': '+esc(s.colour)+', EU '+esc(s.s)+'"><span class="wmb-slot__img"><img src="'+img(s.img,160)+'" alt="" width="56" height="70"></span><span class="wmb-slot__t"><small>Pair '+(i+1)+'</small>'+esc(LABEL)+'<span>'+esc(s.colour)+' · EU '+esc(s.s)+'</span></span><span class="wmb-slot__p">'+money(s.p)+'<br><button type="button" class="wmb-slot__x" data-rm="'+i+'" aria-label="Remove pair '+(i+1)+'">'+X+'</button></span></div>';
  }
  function render(){
    renderCols();renderSizes();
    var h='';for(var i=0;i<QTY;i++)h+=slotHTML(i);slotsEl.innerHTML=h;
    var n=filled(),done=n===QTY,left=QTY-n,was=wasTotal(),save=was-PRICE;
    count.textContent=n+' of '+QTY+' chosen';
    meter.style.transform='scaleX('+(n/QTY)+')';
    title.textContent=done&&!editing?'Both pairs chosen':'Choosing pair '+(active+1)+' of '+QTY;
    if(wasEl)wasEl.textContent=money(was);
    if(wasLabel){var same=slots.every(function(s){return !s||s.p===UNIT});wasLabel.textContent=same?QTY+' pairs at '+money(UNIT):QTY+' pairs'}
    if(saveEl)saveEl.textContent=money(save);
    atc.disabled=!done;
    atc.textContent=done?'Add both to bag · '+money(PRICE):(left===1?'Choose 1 more pair':'Choose '+QTY+' pairs');
    barS.innerHTML=slots.map(function(s,i){return s?'<span class="f"><img src="'+img(s.img,120)+'" alt="" width="36" height="45"></span>':'<span>'+(i+1)+'</span>'}).join('');
    barT.textContent=done?'Save '+money(save)+' · '+slots.map(function(s){return s.colour}).join(' + '):(left===1?'Choose 1 more pair':'Choose '+QTY+' pairs');
    barP.innerHTML=done&&save>0?'<span class="wmb-strike">'+money(was)+'</span> '+money(PRICE):moneyShort(PRICE)+' for '+QTY;
    barBtn.textContent=done?'Add both':'Choose pairs';
  }
  function msg(t,err){msgEl.textContent=t;msgEl.classList.add('show');clearTimeout(msg.t);if(!err)msg.t=setTimeout(function(){msgEl.classList.remove('show')},2600)}
  function setErr(t){errEl.textContent=t||'';errEl.hidden=!t}

  cols.addEventListener('click',function(e){var b=e.target.closest('.wmb-col');if(!b)return;cur=b.getAttribute('data-key');render()});
  sizes.addEventListener('click',function(e){
    var b=e.target.closest('.wm-sz');if(!b||b.disabled)return;
    var c=byKey[cur],v=c.v.filter(function(x){return String(x.id)===b.getAttribute('data-id')})[0];if(!v)return;
    slots[active]={id:v.id,key:c.key,colour:c.colour,s:v.s,p:v.p,img:c.img,handle:c.handle};
    setErr('');
    msg('Pair '+(active+1)+' added: '+c.colour+', EU '+v.s);
    var next=null;for(var i=0;i<QTY;i++){if(!slots[i]){next=i;break}}
    editing=false;if(next!==null)active=next;
    render();
  });
  slotsEl.addEventListener('click',function(e){
    var rm=e.target.closest('[data-rm]');
    if(rm){var i=+rm.getAttribute('data-rm');slots[i]=null;active=i;editing=true;setErr('');render();return}
    var s=e.target.closest('[data-slot]');if(!s)return;
    active=+s.getAttribute('data-slot');editing=true;if(slots[active])cur=slots[active].key;render();
    if(matchMedia('(max-width:899px)').matches&&build)build.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
  });
  slotsEl.addEventListener('keydown',function(e){if((e.key==='Enter'||e.key===' ')&&e.target.matches('.wmb-slot.full')){e.preventDefault();e.target.click()}});

  /* refresh live availability after a cart error (e.g. sold out since page load) */
  function refresh(){
    var hs={};slots.forEach(function(s){if(s)hs[s.handle]=1});
    return Promise.all(Object.keys(hs).map(function(h){
      return fetch('/products/'+h+'.js').then(function(r){return r.json()}).then(function(p){
        J.cols.forEach(function(c){if(c.handle!==h)return;c.v.forEach(function(v){p.variants.forEach(function(pv){if(pv.id===v.id){v.a=pv.available;v.p=pv.price}})})});
      }).catch(function(){});
    })).then(function(){
      slots.forEach(function(s,i){if(!s)return;var v=byKey[s.key].v.filter(function(x){return x.id===s.id})[0];if(!v||!v.a){slots[i]=null;active=i;cur=s.key}else s.p=v.p});
      render();
    });
  }

  /* add both: ONE POST to /cart/add.js, then hand the cart to the theme so its drawer opens */
  var busy=false;
  function addBoth(){
    if(filled()<QTY){if(build)build.scrollIntoView({behavior:'smooth'});return}
    if(busy)return;busy=true;setErr('');
    atc.setAttribute('aria-busy','true');barBtn.setAttribute('aria-busy','true');
    de.dispatchEvent(new CustomEvent('theme:loading:start',{bubbles:true}));
    var sections=[];de.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections',{bubbles:true,detail:{sections:sections}}));
    var body={items:slots.map(function(s){return {id:s.id,quantity:1}})};
    if(sections.length){body.sections=sections.join(',');body.sections_url=location.pathname}
    var root_=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
    fetch(root_+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)})
      .then(function(r){return r.json().then(function(j){return {ok:r.ok,j:j}})})
      .then(function(res){
        if(!res.ok){throw new Error(res.j.description||res.j.message||'Sorry, we could not add these pairs. Please try again.')}
        return fetch(root_+'cart.js').then(function(r){return r.json()}).then(function(cart){
          cart.sections=res.j.sections;
          var ev={bubbles:true,detail:{items:res.j.items||[],cart:cart,onSuccessDo:'force_open_drawer'}};
          d.dispatchEvent(new CustomEvent('variant:add',ev));
          de.dispatchEvent(new CustomEvent('cart:change',{bubbles:true,detail:{baseEvent:'variant:add',onSuccessDo:'force_open_drawer',cart:cart}}));
          msg('Added to your bag');
          if(window.themeVariables&&themeVariables.settings&&themeVariables.settings.cartType==='page')location.href=root_+'cart';
        });
      })
      .catch(function(err){setErr(err.message);d.dispatchEvent(new CustomEvent('cart:refresh'));return refresh()})
      .then(function(){busy=false;atc.removeAttribute('aria-busy');barBtn.removeAttribute('aria-busy');de.dispatchEvent(new CustomEvent('theme:loading:end',{bubbles:true}))});
  }
  atc.addEventListener('click',addBoth);barBtn.addEventListener('click',addBoth);

  /* mobile bar: visible from load (builder is above the fold), hidden while the tray is on screen */
  de.classList.add('wmb-has-bar');
  function showBar(on){bar.classList.toggle('show',on);de.classList.toggle('wmb-bar-on',on&&matchMedia('(max-width:899px)').matches)}
  showBar(true);
  if('IntersectionObserver' in window&&tray){new IntersectionObserver(function(es){es.forEach(function(e){showBar(!e.isIntersecting)})},{threshold:.35}).observe(tray)}

  render();
})();
